import RHFDateRangePicker from "./rhf-date-range-picker.component";

export default RHFDateRangePicker;
